__turbopack_context__.v({
  "btn": "DcaLibrary-module__c0yXha__btn",
  "btnPrimary": "DcaLibrary-module__c0yXha__btnPrimary",
  "btnSecondary": "DcaLibrary-module__c0yXha__btnSecondary",
  "card": "DcaLibrary-module__c0yXha__card",
  "cardHeader": "DcaLibrary-module__c0yXha__cardHeader",
  "description": "DcaLibrary-module__c0yXha__description",
  "exchangeChip": "DcaLibrary-module__c0yXha__exchangeChip",
  "exchangeList": "DcaLibrary-module__c0yXha__exchangeList",
  "footer": "DcaLibrary-module__c0yXha__footer",
  "grid": "DcaLibrary-module__c0yXha__grid",
  "intro": "DcaLibrary-module__c0yXha__intro",
  "kindChip": "DcaLibrary-module__c0yXha__kindChip",
  "meta": "DcaLibrary-module__c0yXha__meta",
  "metaLabel": "DcaLibrary-module__c0yXha__metaLabel",
  "metaRow": "DcaLibrary-module__c0yXha__metaRow",
  "metaValue": "DcaLibrary-module__c0yXha__metaValue",
  "name": "DcaLibrary-module__c0yXha__name",
  "notes": "DcaLibrary-module__c0yXha__notes",
  "planLink": "DcaLibrary-module__c0yXha__planLink",
  "planNote": "DcaLibrary-module__c0yXha__planNote",
  "root": "DcaLibrary-module__c0yXha__root",
  "statusMsg": "DcaLibrary-module__c0yXha__statusMsg",
});
